export const mapExifOrientationToNumber = (
    key: string | number
): number => {

    if (typeof key === 'number') {
        return key;
    }

    const orientations: { [key: string]: number } = {
        'Horizontal (normal)': 1,
        'Mirror horizontal': 2,
        'Rotate 180': 3,
        'Mirror vertical': 4,
        'Mirror horizontal and rotate 270 CW': 5,
        'Rotate 90 CW': 6,
        'Mirror horizontal and rotate 90 CW': 7,
        'Rotate 270 CW': 8
    };

    return orientations[key] || 1;
};